import SectionHelp from '../templates/SectionHelp.mdx';
import ExampleChannelsFrameButton from '../example-buttons/ExampleChannelsFrameButton.vue';
import ExampleUnAssignedChannelsFrameButton from '../example-buttons/ExampleUnAssignedChannelsFrameButton.vue';
import QueueDeck from '../docs-component-level/QueueDeck.mdx';

export function InteractMode() {
  return <v-icon>mdi-gesture-double-tap</v-icon>;
}

export function QueueDeckButton() {
  return <v-icon>mdi-play-speed</v-icon>;
}

export function PinnedVariablesButton() {
  return <v-icon>mdi-pin</v-icon>;
}

export function PlaylistEdit() {
  return <v-icon>mdi-playlist-edit</v-icon>;
}
export function AddChannel() {
  return <v-btn prepend-icon="mdi-plus">Assign Channel</v-btn>;
}

export function AddQueue() {
  return <v-icon>mdi-plus</v-icon>;
}

export function Canvas() {
  return (
    <>
      <v-icon>mdi-blur</v-icon>Canvas
    </>
  );
}

# OnAir Page

This page is where you control what goes on air.

You can assign different Channels (collection of Queues) to each Frame of your Canvas.

You can also change your Channel while the Channel is running, or change each Queue or Scene.
{/* Editor note: As long as the Scene isn't running? */}

<SectionHelp />

## Switch Frames

Click on the Frame that you would like to switch to on the left:

<ExampleChannelsFrameButton
  number="1"
  color="#5d6ae3"
/>
<ExampleUnAssignedChannelsFrameButton
  number="2"
  color="#EC407A"
/>
<ExampleUnAssignedChannelsFrameButton
  number="3"
  color="#9C27B0"
/>

<ExampleUnAssignedChannelsFrameButton
  number="4"
  color="#F44336"
/>

Assigned / Unassigned Icons

<ExampleChannelsFrameButton
  number="1"
  color="#5d6ae3"
/>
/
<ExampleUnAssignedChannelsFrameButton
  number="1"
  color="#5d6ae3"
/>

## Add a Channel to a Frame

If there isn't a Channel Assigned to a Frame then, click <AddChannel /> then select the Channel you want to Assign to this Frame and click **ASSIGN**.

You can also Create a Channel and assign it in this menu.

If there is already a Channel assigned, then see **Swap a Channel in Frame to a different Channel** below.

## Remove a Channel from a Frame.

Click the Frame Preview (top left), select the "Swap Channel". then click **REMOVE CHANNEL**.

## Swap a Channel in Frame to a different Channel

Click the Frame Preview (top left), select the "Swap Channel" tab then click the Channel you would like to use and click **ASSIGN**.

## Modes:

To the right of the Canvas, you can see the current Mode. Click on the Mode Icon to change it.

### <QueueDeckButton/> QueueDeck

This is the default mode for OnAir, and less you add, remove and rearrange Queues and Scenes within the assigned Channel.

### <InteractMode/> Interactive

This lets you update the currently live scene in real-time. Note: None of the changes are saved. The scene will revert back to it's saved state when the scene is next played.

### <PinnedVariablesButton/> Pinned Variables

Pinned Variables let you arbitrary override any scene data with the same name. This can be very powerful.
This affects all scenes with the same variable name, use with caution.

## Canvas

Here you can change your Canvas Preview to a custom stream (instead of the default Graphics Engine Output). (Click <Canvas />)

## Controlling the Channel Queues

<QueueDeck />
